<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-10",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 30,
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'cardBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Skin.png'),
        mainTitle: 'Your skin problems or concerns are:',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Wrinkles',
              icon: require('@/assets/icon/questionIcon/34-Wrinkles.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/34-Wrinkles.png'),
            },{
              text: 'Elasticity',
              icon: require('@/assets/icon/questionIcon/29-Elasticity.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/34-Elasticity.png'),
            },{
              text: 'General aging',
              icon: require('@/assets/icon/questionIcon/29-General aging.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/34-General aging.png'),
            }
          ],[
            {
              text: 'Breakouts',
              icon: require('@/assets/icon/questionIcon/29-Breakouts.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/34-Breakouts.png'),
            },{
              text: 'Hyperpigmentation',
              icon: require('@/assets/icon/questionIcon/29-Hyperpigmentation.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/34-Hyperpigmentation.png'),
            },{
              text: 'None',
              icon: require('@/assets/icon/questionIcon/29-None.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/34-None.png'),
              unique: true,
            }
          ]
        ],
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Hair') !== -1){
          return '/questionnaire/section2/11'
        }else if(this.$store.state.qsData[21].answer.indexOf('Emotion') !== -1){
          return '/questionnaire/section2/13'
        }else if(this.$store.state.qsData[21].answer.indexOf('Menstrual problems') !== -1){
          return '/questionnaire/section2/16'
        }else if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section3'
        }
      }else{
        return '/questionnaire/section3'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
